"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = reduceStatuses;

var _Status = require("./Status"); // Takes any number of statuses and returns a value based on using the bitwise operator


function reduceStatuses() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (developingStatus, status) {
    return new _Status.Status(developingStatus.value | status.value);
  }, new _Status.Status());
}